import { NgModule } from "@angular/core";
import { StepService } from "../../..//services";
import { CircCommonModule } from "../../../common/common.module";
import { LogClass, Logger } from "../../../logger";
import { StepTypeCommonModule } from "../common/step-type-common.module";
import { STEPTYPE_FORINFORMATION } from "../constants";
import { CreateTemplateComponent } from "./create-template/create-template.component";
import { CreateComponent } from "./create/create.component";
import { EditTemplateComponent } from "./edit-template/edit-template.component";
import { EditComponent } from "./edit/edit.component";
import { WorkComponent } from "./work/work.component";

@NgModule({
  declarations: [
    CreateComponent,
    EditComponent,
    WorkComponent,
    CreateTemplateComponent,
    EditTemplateComponent
  ],
  imports: [CircCommonModule, StepTypeCommonModule]
})
@LogClass({ source: "StepTypeForInformationModule" })
export class StepTypeForInformationModule {
  private logger: Logger;

  constructor(stepService: StepService) {
    this.logger.debug("ctor");

    stepService.register({
      id: STEPTYPE_FORINFORMATION,
      name: "step_forInformation_new_name",
      description: "step_forInformation_new_description",
      createComponent: CreateComponent,
      editComponent: EditComponent,
      workComponent: WorkComponent,
      createTemplateComponent: CreateTemplateComponent,
      editTemplateComponent: EditTemplateComponent
    });
  }
}
